import { ajax } from 'rxjs/ajax'
import { retry } from 'rxjs/operators'
import envGet from 'Support/Env/Get/EnvGet.support'
import { ServiceHeadersContentTypeJson } from 'Constants/Service/json-headers'

const BASE_URL_FLITCH = envGet({ key: `REACT_APP_BORAL_BASE_URL_FLITCH` }) as string
const ORDER_TOO_LATE_FOR_PLUS_LOAD_URL = envGet({ key: `REACT_APP_BORAL_ORDER_TOO_LATE_FOR_PLUS_LOAD_URL` }) as string

interface Options {
  authHeaders?: any,
  httpService: HttpService,
  orderKey: string,
}

export interface IsTooLateForPlusLoadServiceResult {
  isToLateForPlusLoad: boolean,
}

const isTooLateForPlusLoadService = async (options: Options): Promise<IsTooLateForPlusLoadServiceResult> => {
  const {
    authHeaders = {},
    httpService,
    orderKey,
  } = options
  const headers = {
    ...authHeaders,
    ...ServiceHeadersContentTypeJson,
  }
  const url = `${BASE_URL_FLITCH}${ORDER_TOO_LATE_FOR_PLUS_LOAD_URL.replace(`{ORDER_KEY}`, orderKey)}`

  return httpService.get(url, { headers })
}

export default isTooLateForPlusLoadService
